/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_MembersInputs */

const en_us2_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members`)
};

const pt_br2_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros`)
};

const es_419_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miembros`)
};

const pt_pt2_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membros`)
};

const fr_fr2_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membres`)
};

const de_de2_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitglieder`)
};

const it_it2_clubs_members = /** @type {(inputs: Clubs_MembersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Membri`)
};

/**
* | output |
* | --- |
* | "Members" |
*
* @param {Clubs_MembersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_members = /** @type {((inputs?: Clubs_MembersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_MembersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_members(inputs)
	if (locale === "es-419") return es_419_clubs_members(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_members(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_members(inputs)
	if (locale === "de-DE") return de_de2_clubs_members(inputs)
	if (locale === "it-IT") return it_it2_clubs_members(inputs)
	return en_us2_clubs_members(inputs)
});
export { clubs_members as "clubs.members" }